// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProductShipping-messagesSelected p{color:#34a853}.ProductShipping-messagesSelected .icon--inline.Icon-Valide{margin-right:5px}.ProductShipping-messagesSelected .disabledBtn{display:none}", ""]);
// Exports
module.exports = exports;
